import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ItemCheckListChangeModel, ItemCheckListModel} from '../../../../models/check-lists/check-list-model';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {ItemModel, MenuEventArgs} from '@syncfusion/ej2-angular-splitbuttons';

@Component({
  selector: 'app-item-checklist',
  templateUrl: './item-checklist.component.html',
  styleUrls: ['./item-checklist.component.scss'],
})
export class ItemChecklistComponent implements OnInit, OnDestroy {
  private form: UntypedFormGroup;
  libelle: UntypedFormControl = new UntypedFormControl();
  estCoche: UntypedFormControl = new UntypedFormControl();
  private _modeEdition: boolean;
  private _initialLibelle: string;
  MENU_SUPPRIMER = 'menuSupprimer';
  MENU_MODIFIER = 'menuModifier';

  private _item: ItemCheckListModel;
  @Input() set item(value: ItemCheckListModel) {
    this._item = value;
  }
  get item() {
    return this._item;
  }

  private _order: number;
  @Input() set order(value: number) {
    this._order = value;
  }
  private _editable: boolean;
  @Input() set editable(value: boolean) {
    this._editable = value;
  }

  private _canDelete: boolean;
  @Input() set canDelete(value: boolean) {
    this._canDelete = value;
  }

  @Output() modeEditionChange = new EventEmitter<boolean>();
  @Output() changeItem: EventEmitter<ItemCheckListChangeModel> = new EventEmitter<ItemCheckListChangeModel>();
  @Output() deleteItem: EventEmitter<number> = new EventEmitter<number>();
  @ViewChild('inputFocus') inputFocus: ElementRef;

  set modeEdition(value: boolean) {
    this._initialLibelle = this._item.libelle;
    this._modeEdition = value;
    this.modeEditionChange.emit(value);
  }

  get modeEdition(): boolean {
    return this._modeEdition;
  }

  public menu: ItemModel[];

  constructor(private formBuilder: UntypedFormBuilder) {
    this.form = this.formBuilder.group({
      libelle: this.libelle,
      estCoche: this.estCoche,
    });
  }

  switchModeEdition(): void {
    this.modeEdition = true;
    setTimeout(() => {
      this.libelle.setValue(this._item.libelle); // pour validité initiale
      this.inputFocus.nativeElement.value = this._item.libelle;
      this.inputFocus.nativeElement.focus();
    }, 0);
  }

  saveLibelleItem() {
    if (this._editable) {
      this.changeItem.emit(
        Object.assign(new ItemCheckListChangeModel(), this._item, {
          order: this._order,
          libelle: this.libelle.value,
          estCoche: this.item.estCoche,
        }),
      );
      this.modeEdition = false;
    }
  }

  saveEstCocheItem() {
    if (this._editable) {
      const input: HTMLElement = document.getElementById(this.getHTMLElementId());
      this.estCoche.setValue((input as HTMLInputElement).checked);
      this.changeItem.emit(
        Object.assign(new ItemCheckListChangeModel(), this._item, {
          order: this._order,
          libelle: this.item.libelle,
          estCoche: this.estCoche.value,
        }),
      );
      this.modeEdition = false;
    }
  }

  setItemDeleted() {
    if (this._canDelete) {
      this.deleteItem.emit(this._order);
    }
  }

  ngOnInit() {
    this.menu = [
      {
        text: 'Modifier',
        id: this.MENU_MODIFIER,
      },
    ];
    if (this._canDelete) {
      this.menu.push({
        text: 'Supprimer',
        id: this.MENU_SUPPRIMER,
      });
    }
  }

  ngOnDestroy() {}

  isLibelleInvalide() {
    return this.libelle.value == null || this.libelle.value.trim().length == 0;
  }

  menuActions(args: MenuEventArgs) {
    if (args.item.id === this.MENU_MODIFIER) {
      this.switchModeEdition();
    }
    if (args.item.id === this.MENU_SUPPRIMER) {
      this.setItemDeleted();
    }
  }

  getHTMLElementId(): string {
    return 'order' + this._order;
  }
}
